import {
  AUTH_HOST,
  SA_APP_ALIAS,
  SA_CLIENT_ID,
  SA_STATE,
} from '@/config/constants';
import { SamsungUserDetails } from './type';
import { authStorage, keycloak, sbaas } from '@/config';
import * as utils from '@/components/utils';

type AccessTokenParams = {
  code?: string;
  refreshToken?: string;
};

export const logInUser = (redirect_uri: string) => {
  const urlLogin = new URL(
    `${AUTH_HOST}/accounts/v1/${SA_APP_ALIAS}/signInGate`,
  );
  urlLogin.searchParams.append('client_id', SA_CLIENT_ID);
  urlLogin.searchParams.append('response_type', 'code');
  urlLogin.searchParams.append('redirect_uri', redirect_uri);
  urlLogin.searchParams.append('state', SA_STATE);
  urlLogin.searchParams.append('scope', 'offline.access');
  window.location.assign(urlLogin.href);
};

export const getAccessToken = async (
  access: AccessTokenParams,
  redirect_uri: string,
) => {
  if (access.code) {
    try {
      const api = await sbaas.script('sa_token').post({
        body: {
          code: access.code,
          redirect_uri: redirect_uri,
        },
      });
      const aToken = api.data;
      if (aToken.access_token) {
        return {
          accessToken: aToken.access_token,
          refreshToken: aToken.refresh_token,
          userId: aToken.userid,
        };
      }
    } catch (err) {
      console.log('#Get Token Error::', err);
    }
  }
  return undefined;
};

export const validateAccessToken = async (token: string) => {
  try {
    const vToken = await sbaas.script('sa_validate').post({
      body: {
        authToken: token,
      },
    });
    return vToken.data.status;
  } catch (err) {
    console.log('##Error Validate Token', err);
    return false;
  }
};

export const getUserDetails = async (token: string, userId: string) => {
  const userData = await sbaas.script('sa_userinfo').post({
    body: {
      accessToken: token,
      userId: userId,
    },
  });
  return userData.data as SamsungUserDetails;
};

export const logOutUser = async () => {
  await authStorage.store(undefined, false).then(async _ => {
    clearLocalStorage();
    if (keycloak && keycloak.instance)
      await keycloak.instance.logout({ redirectUri: window.location.origin });
    else window.open(window.location.origin, '_self');
  });
};

export const clearLocalStorage = () => {
  utils.removeStorage('AD_T');
  utils.removeStorage('AD_R');
  utils.removeStorage('AD_ID');
  utils.removeStorage('KC_AT');
  utils.removeStorage('KC_RT');
  utils.removeStorage('KC_ID');
  utils.removeStorage('KC_DT');

  utils.removeStorage('S2S_T');
  utils.removeStorage('S2S_D');

  utils.removeStorage('AD_C');
  utils.removeStorage('AD_S');
  utils.removeStorage('AD_O');

  utils.removeStorage('MN_DATA');
  utils.removeStorage('MN_USED');
};
